import axios from "axios";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_INSUREDS_LIST: "applications/FETCH_INSUREDS_LIST",
  FETCH_INSURED_DETAILS: "applications/FETCH_INSURED_DETAILS",
  FETCH_INSURED_OPTIONS: "applications/FETCH_INSURED_OPTIONS",
  SAVE_INSUREDS: "applications/SAVE_INSURED",
};

const initialState = {
  loading: false,
  insuredsList: [],
  insuredDetails: null,
};

export type ApplicationInsuredsState = Readonly<typeof initialState>;

/**
 * ApplicationInsureds Reducer
 */
export default (state: ApplicationInsuredsState = initialState, action): ApplicationInsuredsState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_INSUREDS_LIST):
    case PENDING(ACTION_TYPES.FETCH_INSURED_DETAILS):
    case PENDING(ACTION_TYPES.FETCH_INSURED_OPTIONS):
    case PENDING(ACTION_TYPES.SAVE_INSUREDS):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_INSUREDS_LIST): {
      return {
        ...state,
        loading: false,
        insuredsList: action.payload.data,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_INSURED_DETAILS):
      return { ...state, loading: false, insuredDetails: action.payload.data };

    case FULFILLED(ACTION_TYPES.FETCH_INSURED_OPTIONS):
      return { ...state, loading: false, insuredDetails: action.payload.data };

    case FULFILLED(ACTION_TYPES.SAVE_INSUREDS): {
      const newInsured = action.payload.data;
      return {
        ...state,
        loading: false,
        insuredsList: [newInsured, ...state.insuredsList],
      };
    }

    case REJECTED(ACTION_TYPES.FETCH_INSUREDS_LIST):
    case REJECTED(ACTION_TYPES.FETCH_INSURED_DETAILS):
    case REJECTED(ACTION_TYPES.FETCH_INSURED_OPTIONS):
    case REJECTED(ACTION_TYPES.SAVE_INSUREDS):
      return { ...state, loading: false };

    default:
      return state;
  }
};

/**
 * Action to fetch additional insureds list
 */
export const fetchAppInsuredsList = (applicationId: string) => ({
  type: ACTION_TYPES.FETCH_INSUREDS_LIST,
  meta: { applicationId },
  payload: axios.get(`/applications/${applicationId}/insureds`),
});

export const fetchAppInsuredDetails = (insuredId: number) => ({
  type: ACTION_TYPES.FETCH_INSURED_DETAILS,
  payload: axios.get(`applications/insureds/${insuredId}`),
});

export const fetchAppInsuredOptions = () => ({
  type: ACTION_TYPES.FETCH_INSURED_OPTIONS,
  payload: axios.get(`applications/insured/new`),
});

/**
 * Action to save a new or edit an existing additional insured
 */

export const saveAppInsureds = (applicationId, insuredsData) => ({
  type: ACTION_TYPES.SAVE_INSUREDS,
  payload: axios.post(`applications/${applicationId}/insureds`, insuredsData, {
    headers: { "Content-Type": "application/json" },
  }),
});
